const toggleCollapse = (collapse = false, action) => {
    switch (action.type) {
        case 'TOGGLE_COLLAPSE':
            return !collapse
        default:
            return collapse
    }
}
export default toggleCollapse;